<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h2>เพิ่มสมาชิกทีม</h2>
        </div>
        <v-form ref="form" @submit.prevent="addTeam()">
            <v-card class="mb-3">
                <div class="pa-3">

                    <v-row>
                        <v-col cols="12">
                            ข้อมูลส่วนตัว
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <div class="image_add_team_list">
                                <img v-if="imagePreviewURL" :src="imagePreviewURL"/>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="image" label="เพิ่มรูปบัตรประชาชน" @change="onFileChange"></v-file-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field :label="`รหัส ${code}`" color="primary" outlined disabled></v-text-field>
                            <v-text-field label="เบอร์โทร" v-model="tel" type="tel" maxlength="10" @keypress="isNumber($event)" onpaste="return false" color="primary" :rules="[v => !!v || 'กรุณากรอกเบอร์โทร']" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="ชื่อ-สกุล" v-model="name" color="primary" :rules="[v => !!v || 'กรุณากรอกชื่อ-สกุล']" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="ชื่อเล่น" v-model="nickname" color="primary" :rules="[v => !!v || 'กรุณากรอกชื่อเล่น']" required outlined></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            ตั้งรหัสผ่าน
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field label="รหัสผ่าน" :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']" v-model="password" :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'" :type="show_password ? 'text' : 'password'" @click:append="show_password = !show_password" color="primary" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="ยืนยันรหัสผ่าน" :rules="[v => !!v || 'กรุณากรอกยืนยันรหัสผ่าน']" v-model="password_confirm" :append-icon="show_confirm_password ? 'mdi-eye' : 'mdi-eye-off'" :type="show_confirm_password ? 'text' : 'password'" @click:append="show_confirm_password = !show_confirm_password" color="primary" required outlined></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            สิทธิ์การเข้าถึง
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-radio-group class="mt-0" v-model="permission_type" :rules="[v => !!v || 'กรุณาเลือกสิทธิ์การเข้าถึง']" required hide-details="auto">
                                <div class="d-flex">
                                    <div class="d-flex">
                                        <v-radio color="primary" class="mb-0" value="0"></v-radio>
                                        <div class="mr-1">สิทธิ์แบบตั้งค่าเอง</div>
                                    </div>
                                    <div class="d-flex">
                                        <v-radio color="primary" class="mb-0" value="1"></v-radio>
                                        <div class="mr-1">สิทธิ์ Admin</div>
                                    </div>
                                </div>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
            <v-card class="my-3" v-if="permission_type == 0">
                <div class="pa-3">
                    <v-row>

                        <v-col cols="12">
                            เมนูทีมงาน
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_my_team"></v-checkbox>
                                <div>ทีมงานของฉัน</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_add_team"></v-checkbox>
                                <div>เพิ่มทีมงาน</div>
                            </div>
                        </v-col>

                        <v-col cols="12">
                            ยอดขาย
                        </v-col>
                        <!-- <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_cost_sell"></v-checkbox>
                                <div>รายงานต้นทุนขายรายวัน</div>
                            </div>
                        </v-col> -->
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_statistic_food"></v-checkbox>
                                <div>ดูสถิติยอดขายอาหาร</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_see_all_report"></v-checkbox>
                                <div>ดูรายงานทั้งหมด</div>
                            </div>
                        </v-col>

                        <v-col cols="12">
                            เมนูคลัง
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_inventory_report"></v-checkbox>
                                <div>ดูรายงานคลัง</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_raw_material"></v-checkbox>
                                <div>วัตถุดิบคงเหลือ</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_materials_add_warehouse"></v-checkbox>
                                <div>นำวัตถุดิบเข้าคลัง</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_warehouse_in_out"></v-checkbox>
                                <div>ดูรายการ เข้า - ออก คลัง</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_material_purchase_order"></v-checkbox>
                                <div>ใบสั่งซื้อวัตถุดิบ</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_setup_stock"></v-checkbox>
                                <div>ตั้งค่าข้อมูลเกี่ยวกับคลัง</div>
                            </div>
                        </v-col>

                        <v-col cols="12">
                            เมนูร้านอาหาร
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_add_food"></v-checkbox>
                                <div>เพิ่มอาหารและท๊อปปิ้ง</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_edit_food"></v-checkbox>
                                <div>แก้ไขอาหารและท๊อปปิ้ง</div>
                            </div>
                        </v-col>
                        <!-- <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_setup_buffe"></v-checkbox>
                                <div>จัดการบุฟเฟ่ต์</div>
                            </div>
                        </v-col> -->
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_setup_advertise"></v-checkbox>
                                <div>จัดการโฆษณา</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_invoice_retrospect"></v-checkbox>
                                <div>ดูรายการบิลย้อนหลังทั้งหมด</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_report_retrospect"></v-checkbox>
                                <div>ดูรายงานย้อนหลัง</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_see_close"></v-checkbox>
                                <div>ดูรายการปิดร้านย้อนหลัง</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="per_setting_store"></v-checkbox>
                                <div>จัดการตั้งค่าข้อมูลร้านอาหาร</div>
                            </div>
                        </v-col> 
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="pre_cancel_table"></v-checkbox>
                                <div>ยกเลิกโต๊ะ</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="pre_cancel_food"></v-checkbox>
                                <div>ยกเลิกอาหาร</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="pre_cancel_bill"></v-checkbox>
                                <div>ยกเลิกบิล</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="pre_change_table"></v-checkbox>
                                <div>ย้ายโต๊ะ</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="pre_close_res"></v-checkbox>
                                <div>ปิดร้าน</div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="d-flex">
                                <v-checkbox color="primary" class="ma-0" v-model="pre_checkbill"></v-checkbox>
                                <div>เช็คบิล</div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
            <v-row>
                <v-col cols="4"></v-col>
                <v-col cols="4">
                    <v-btn color="#28ab28" class="title_font_add_team white--text" type="submit" width="100%" height="50">
                        บันทึก
                    </v-btn>
                </v-col>
                <v-col cols="4"></v-col>
            </v-row>
        </v-form>
        <v-dialog v-model="alert_show_add" persistent max-width="600">
            <v-card>
                <v-card-title>
                    สำเร็จ
                </v-card-title>

                <v-card-text>
                    เพิ่มสมาชิกทีมเรียบร้อย
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="confirmSuccess()">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="alert_error" persistent max-width="600">
            <v-card>
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    {{ text_error }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="alert_error = false">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/id_card.png";
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            imagePreviewURL: before_image,
            alert_show_add: false,
            alert_error: false,
            text_error: "",
            image: null,
            code: null,
            name: null,
            nickname: null,
            tel: null,
            password: null,
            password_confirm: null,
            permission_type: null,
            //เมนูทีมงาน
            per_my_team: 0,
            per_add_team: 0,
            //ยอดขาย
            per_cost_sell: 0,
            per_statistic_food: 0,
            per_see_all_report: 0,
            //เมนูคลัง
            per_inventory_report: 0,
            per_raw_material: 0,
            per_materials_add_warehouse: 0,
            per_warehouse_in_out: 0,
            per_material_purchase_order: 0,
            per_setup_stock: 0,
            //เมนูร้านอาหาร
            per_add_food: 0,
            per_edit_food: 0,
            per_setup_buffe: 0,
            per_setup_advertise: 0,
            per_invoice_retrospect: 0,
            per_report_retrospect: 0,
            per_see_close: 0,
            per_setting_store: 0,
            pre_cancel_table: 0,
            pre_cancel_food: 0,
            pre_cancel_bill: 0,
            pre_change_table: 0,
            pre_close_res: 0,
            pre_checkbill: 0,
            show_password: false,
            show_confirm_password: false
        }
    },
    methods: {
        async onFileChange(payload) {
            const file = payload
            if (file) {
                this.imagePreviewURL = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
            } else {
                this.imagePreviewURL = before_image
            }
        },
        async getNumber() {
            HTTP.get('/team/gen-code', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.code = response.data.code
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async isNumberBank(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async addTeam() {
            if (this.$refs.form.validate()) {

                if (this.password === null || this.password == '') {
                    this.password = ''
                }

                if (this.password_confirm === null || this.password_confirm == '') {
                    this.password_confirm = ''
                }
                if (this.password != this.password_confirm) {
                    this.text_error = 'รหัสผ่านและยืนยันรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
                    this.alert_error = true
                } else if(this.tel.length < 10){
                    this.text_error = 'เบอร์โทรต้องไม่ต่ำกว่า 10 ตัวเลข กรุณาตรวจสอบใหม่อีกครั้ง'
                    this.alert_error = true
                } else {
                    this.loading_page = true
                    let data = new FormData()
                    data.append('image', this.image)
                    data.append('name', this.name)
                    data.append('nickname', this.nickname)
                    data.append('tel', this.tel)
                    data.append('password', this.password)
                    data.append('password_confirm', this.password_confirm)
                    data.append('permission_type', this.permission_type)

                    if (this.permission_type == 0) {
                        //เมนูทีมงาน
                        data.append('per_my_team', this.per_my_team === true || this.per_my_team == 1 ? 1 : 0)
                        data.append('per_add_team', this.per_add_team === true || this.per_add_team == 1 ? 1 : 0)

                        //ยอดขาย
                        data.append('per_cost_sell', this.per_cost_sell === true || this.per_cost_sell == 1 ? 1 : 0)
                        data.append('per_statistic_food', this.per_statistic_food === true || this.per_statistic_food == 1 ? 1 : 0)
                        data.append('per_see_all_report', this.per_see_all_report === true || this.per_see_all_report == 1 ? 1 : 0)

                        //เมนูคลัง
                        data.append('per_inventory_report', this.per_inventory_report === true || this.per_inventory_report == 1 ? 1 : 0)
                        data.append('per_raw_material', this.per_raw_material === true || this.per_raw_material == 1 ? 1 : 0)
                        data.append('per_materials_add_warehouse', this.per_materials_add_warehouse === true || this.per_materials_add_warehouse == 1 ? 1 : 0)
                        data.append('per_warehouse_in_out', this.per_warehouse_in_out === true || this.per_warehouse_in_out == 1 ? 1 : 0)
                        data.append('per_material_purchase_order', this.per_material_purchase_order === true || this.per_material_purchase_order == 1 ? 1 : 0)
                        data.append('per_setup_stock', this.per_setup_stock === true || this.per_setup_stock == 1 ? 1 : 0)

                        //เมนูร้านอาหาร
                        data.append('per_add_food', this.per_add_food === true || this.per_add_food == 1 ? 1 : 0)
                        data.append('per_edit_food', this.per_edit_food === true || this.per_edit_food == 1 ? 1 : 0)
                        data.append('per_setup_buffe', this.per_setup_buffe === true || this.per_setup_buffe == 1 ? 1 : 0)
                        data.append('per_setup_advertise', this.per_setup_advertise === true || this.per_setup_advertise == 1 ? 1 : 0)
                        data.append('per_invoice_retrospect', this.per_invoice_retrospect === true || this.per_invoice_retrospect == 1 ? 1 : 0)
                        data.append('per_report_retrospect', this.per_report_retrospect === true || this.per_report_retrospect == 1 ? 1 : 0)
                        data.append('per_see_close', this.per_see_close === true || this.per_see_close == 1 ? 1 : 0)
                        data.append('per_setting_store', this.per_setting_store === true || this.per_setting_store == 1 ? 1 : 0)
                        data.append('pre_cancel_table', this.pre_cancel_table === true || this.pre_cancel_table == 1 ? 1 : 0)
                        data.append('pre_cancel_food', this.pre_cancel_food === true || this.pre_cancel_food == 1 ? 1 : 0)
                        data.append('pre_cancel_bill', this.pre_cancel_bill === true || this.pre_cancel_bill == 1 ? 1 : 0)
                        data.append('pre_change_table', this.pre_change_table === true || this.pre_change_table == 1 ? 1 : 0)
                        data.append('pre_close_res', this.pre_close_res === true || this.pre_close_res == 1 ? 1 : 0)
                        data.append('pre_checkbill', this.pre_checkbill === true || this.pre_checkbill == 1 ? 1 : 0)
                    }

                    HTTP.post('/team/create', data, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                this.alert_show_add = true
                                this.loading_page = false
                            }
                            if (response.data.successful === false && response.data.message == "มีผู้ใช้เบอร์นี้แล้ว") {
                                this.text_error = 'มีผู้ใช้เบอร์นี้แล้ว กรุณาตรวจสอบใหม่อีกครั้ง'
                                this.alert_error = true
                                this.loading_page = false
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
            }
        },
        async confirmSuccess() {
            this.$router.push('/myteam')
        },
        async removeTimeWork(item) {
            const index = this.work_shift_id.indexOf(item.id)
            if (index >= 0) this.work_shift_id.splice(index, 1)
        },
    },
    mounted() {
        this.getNumber()
    }
}
</script>

<style scoped>
    .image_add_team_list{
        width: 50%;
    }

    .image_add_team_list > img{
        max-width: 100%;
    }
</style>
